import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';
import { employeesNotDeleted } from '../employees/employees-not-deleted';

export const defaultSelectedEmployeesForShareVacation = createSelector(
  getOrganization,
  employeesNotDeleted,
  (organization, employees): string[] => {
    if (organization === undefined) return [];
    if (organization.vacationSummaryEmployees.length === 0) {
      return employees
        .filter((item) => item.profession === 'Lege')
        .filter((item) => item.status !== 'TERMINATED')
        .map((item) => item.uuid);
    }
    return organization.vacationSummaryEmployees;
  },
);
